export default "__VITE_ASSET__DFMdfegt__"